import React from 'react';

export const LocationCard = ({ location, displayType, onClick, actions }) => {
    return (
        <div className={`location-card ${displayType}`} onClick={onClick}>
            {displayType === 'list' ? (
                <>
                    <div className="content">
                        <h3>{location.name}</h3>
                        <p>{location.description}</p>
                    </div>
                    <div className="model-actions">
                        {actions}
                    </div>
                </>
            ) : (
                <>
                    <h3>{location.name}</h3>
                    <p>{location.description}</p>
                    <div className="model-actions">
                        {actions}
                    </div>
                </>
            )}
        </div>
    );
};

export default LocationCard;
